import React, { useState } from "react";

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", form);
    alert("Thank you! We’ll get back to you soon.");
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="max-w-6xl mx-auto p-6 grid grid-cols-1 md:grid-cols-2 gap-8" style={{marginTop: '6rem'}}>
      {/* Left: Contact Info */}
      <div>
        <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
        <p className="text-gray-600 mb-6">
          Have questions or special requests? Get in touch and we’ll be happy to help.
        </p>

        <div className="space-y-4">
          <p><strong>📍 Address:</strong> Iskon Road, Near Kapiltheertham, Tirupati</p>
          <p><strong>📞 Phone:</strong> +91 9490490077</p>
          <p><strong>✉️ Email:</strong> janashotels@outlook.com</p>
        </div>

        {/* Google Map */}
        <div className="mt-6">
          <iframe
            title="Hotel Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3877.1684419474814!2d79.41592777573027!3d13.647515599698256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4d4b00201bab8f%3A0x5a6c275273e066a8!2sJANAS%20HOTEL!5e0!3m2!1sen!2sin!4v1738928528582!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
          ></iframe>
        </div>
      </div>

      {/* Right: Contact Form */}
      <div>
        <form
          onSubmit={handleSubmit}
          className="bg-white shadow-lg rounded-lg p-6 space-y-4"
          style={{padding: '1rem'}}
        >
          <div>
            <label className="block font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="border rounded p-2 w-full"
            />
          </div>

          <div>
            <label className="block font-medium">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="border rounded p-2 w-full"
            />
          </div>

          <div>
            <label className="block font-medium">Phone</label>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
              className="border rounded p-2 w-full"
            />
          </div>

          <div>
            <label className="block font-medium">Message</label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              rows={4}
              required
              className="border rounded p-2 w-full"
            />
          </div>

          <button
            type="submit"
            className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
            style={{padding: '0.25rem', backgroundColor: 'var(--primary-color)'}}
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}
